export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6108.9020393b.jpg";